import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "btn__label" };
import { closeDialogModal } from "../modal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CloseButton',
    props: {
        modal: { type: Object },
        label: { type: String, default: 'Закрыть' },
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "btn btn--2 btn--m btn--black",
                onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) { return (_unref(closeDialogModal)(__props.modal)); }, ["prevent"])),
                tabindex: "-1"
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1 /* TEXT */)
            ]));
        };
    }
});
